export default __webpack_public_path__ + "static/media/receptionPlusIcon.ffc39726.svg";